import React, { useEffect, useState, useContext } from 'react'
import { Avatar, Chip, Rating, Paper, InputBase, IconButton } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Skeleton from "@mui/material/Skeleton";
import { AuthContext } from '../../context/AuthContext'
import ENDPOINT from '../../context/EndPoint'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import SecurityHeaders from '../../context/SecurityHeaders'
import { useActionsContext } from '../../context/ActionsContext';
import Localbase from "localbase"

const DailyClassFeedbacks = () => {
  const { rowsPerPage, setRowsPerPage } = useActionsContext();
  const params = useParams();
  const { user } = useContext(AuthContext);
  const userdata = user;
  const db = new Localbase("db")

  const [feedbacks, setFeedbacks] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [classes, setClasses] = useState([]); // Added state for customer_tickets

  const getSupportLogs = async () => {
    if (userdata !== null) {
      try {
        const formData = new FormData();
        formData.append('session', user.SessionId);
        if (params.class_id) formData.append('class_id', params.class_id);
        if (params.batch_id) formData.append('batch_id', params.batch_id);
        if (params.course_url) formData.append('course_url', params.course_url);
        formData.append('limit', rowsPerPage);
        const response = await axios.post(`${ENDPOINT}class-feedback.php`, formData, SecurityHeaders);
        if (response.data) {
          db.collection("paths").add({ class_feedbacks: response.data }, "class_feedbacks")
          setFeedbacks(response.data.data || []);
        }
      } catch (error) {
        console.error(error);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    
    db.collection("paths").doc("class_feedbacks").get().then(data => {
      if (data) {
        setClasses(data.class_feedbacks);
      }
    })

    window.scrollTo(0, 0);
    getSupportLogs();
  }, [rowsPerPage]);

  // Filter feedbacks by search term
  const filteredFeedbacks = feedbacks.filter(fb => {
    const term = searchTerm.toLowerCase();
    return (
      (fb.first_name && fb.first_name.toLowerCase().includes(term)) ||
      (fb.phone_number && fb.phone_number.toLowerCase().includes(term)) ||
      (fb.review && fb.review.toLowerCase().includes(term)) ||
      (fb.type && fb.type.toLowerCase().includes(term))
    );
  });

  return (
    <div className="container-fluid py-3">
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
        <h4 className="mb-0">Class Reviews <span className="text-muted fs-6">({feedbacks.length})</span></h4>
        <Paper
          component="form"
          onSubmit={e => e.preventDefault()}
          sx={{ p: '2px 8px', display: 'flex', alignItems: 'center', width: 320, boxShadow: 1 }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search feedbacks"
            inputProps={{ 'aria-label': 'search feedbacks' }}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
          <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
            <SearchIcon />
          </IconButton>
        </Paper>
      </div>
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
              <tr>
                <th>Feedback</th>
                <th>Reviewer</th>
                <th>Rating</th>
                <th>Date</th>
                <th>Category</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5}>
                    <Skeleton variant="rectangular" height={400} />
                  </td>
                </tr>
              ) : filteredFeedbacks.length > 0 ? (
                filteredFeedbacks.map((fb, idx) => (
                  <tr key={idx}>
                    <td style={{ maxWidth: 300, wordBreak: 'break-word' }}>
                      <span>{fb.review}</span>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <Avatar src={fb.profile_pic} sx={{ width: 32, height: 32 }} />
                        <div className="ms-2">
                          <div className="fw-semibold">{fb.first_name} <span className="text-muted">({fb.phone_number})</span></div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <Rating value={Number(fb.rating)} readOnly size="small" />
                    </td>
                    <td>
                      <span className="text-muted">{fb.date_time}</span>
                    </td>
                    <td>
                      {fb?.type ? <Chip label={fb.type} color="primary" size="small" /> : <span className="text-muted">-</span>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-4">
                    No feedbacks found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default DailyClassFeedbacks